export const useBackgroundModalStyles = () => {
  return {

        container: {
          width: '600px',
          minHeight: '400px',
          '& .inputSelect': {
            width: 'calc(100% - 35px)',
          },
        },
        button: {
          float: 'right',
        },
        paper: {
        },
        formControl: {
          display: 'block',
          margin: '1.5em 0',
          '&:first-child': {
            margin: '0 0 1.5em 0',
          },
        },
        label: {
          width: '133%', // Labels have scale(0.75) applied to them, so this effectively makes the width 100%
        },
        drawer: {
          display: 'flex',
          //width: theme.rightDrawerWidth,
          //height: `calc(100% - ${theme.footerHeight}px)`,
        },
        thumbnailContainer: {
          display: 'flex',
          flexWrap: 'wrap',
          padding: '5px',
          overflowY: 'auto',
        },




        thumbContainer: {
          margin: '.3125rem',
          width: 'calc(50% - .625rem)',
          display: 'flex',
          position: 'relative',
          '&::after': {
            content: '""',
            paddingBottom: '55.5%',
          },
        },
        thumbIconContainer: {
          cursor: 'pointer',
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          borderRadius: '.625rem',
  /*
          border: `solid ${theme.palette.grey[400]}`,
          '&.selected': {
            border: `solid ${theme.palette.primary.main}`,
            '& svg': {
              color: `${theme.palette.primary.main}`,
            },
          },
  */
        },
        thumbIcon: {
          height: 50,
          width: 50,
  /*
          color: `${theme.palette.grey[400]}`,
          '&.selected': {
            color: `${theme.palette.primary.main}`,
          },
  */
        },
        thumbImage: {
          width: '100%',
          height: '100%',
          position: 'absolute',
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          objectFit: 'cover',
          borderRadius: '.625rem',
  /*
          border: `solid ${theme.palette.grey[400]}`,
          '&:hover': {
            cursor: 'pointer',
            '& svg': {
              color: `${theme.palette.primary.main}`,
            },
            '& $thumbOverlay': {
              visibility: 'visible',
            },
          },
          '&.selected': {
            border: `solid ${theme.palette.primary.main}`,
            '& svg': {
              color: `${theme.palette.primary.main}`,
            },
          },
  */
        },
        thumbOverlay: {
          position: 'absolute',
          color: 'transparent',
          padding: '1.25rem',
          fontSize: '.875rem',
          fontWeight: 'bold',
          width: '100%',
          height: '100%',
          borderRadius: '.625rem',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          '&:hover': {
            background: 'rgba(95, 93, 128, 0.6)',
            color: 'white',
          },
        },



  }
}